module.exports = __webpack_public_path__ + "pisces-48deb67292a2cb18a67c.png";